export const ordersCancellationsContext = {
  all: '/order-service/rest/api/external/paymentRefunds',
  markAsRefunded: '/order-service/rest/api/external/paymentRefunds/{id}/markAsRefunded',
};
